import { jsx as ___EmotionJSX } from "@emotion/core";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import { SmallHeadline } from '@dfds-ui/react-components';
import ModalHeader from './ModalHeader';
import ModalCloseButton from './ModalCloseButton';
import ModalDialog, { defaultProps } from './ModalDialog';
import ModalBody from './ModalBody';
import ModalActionsContainer from './ModalActionsContainer';
export var Modal = function Modal(_ref) {
  var _ref$showClose = _ref.showClose,
      showClose = _ref$showClose === void 0 ? true : _ref$showClose,
      heading = _ref.heading,
      headerClassName = _ref.headerClassName,
      _ref$noContentPadding = _ref.noContentPadding,
      noContentPadding = _ref$noContentPadding === void 0 ? false : _ref$noContentPadding,
      onRequestClose = _ref.onRequestClose,
      children = _ref.children,
      _ref$closeTabIndex = _ref.closeTabIndex,
      closeTabIndex = _ref$closeTabIndex === void 0 ? -1 : _ref$closeTabIndex,
      _ref$closeLabel = _ref.closeLabel,
      closeLabel = _ref$closeLabel === void 0 ? 'Close' : _ref$closeLabel,
      _ref$column = _ref.column,
      column = _ref$column === void 0 ? false : _ref$column,
      _ref$zIndex = _ref.zIndex,
      zIndex = _ref$zIndex === void 0 ? defaultProps.zIndex : _ref$zIndex,
      _ref$sizes = _ref.sizes,
      sizes = _ref$sizes === void 0 ? defaultProps.sizes : _ref$sizes,
      _ref$renderWhenClosed = _ref.renderWhenClosed,
      renderWhenClosed = _ref$renderWhenClosed === void 0 ? defaultProps.renderWhenClosed : _ref$renderWhenClosed,
      _ref$backdrop = _ref.backdrop,
      backdrop = _ref$backdrop === void 0 ? defaultProps.backdrop : _ref$backdrop,
      _ref$backdropVariant = _ref.backdropVariant,
      backdropVariant = _ref$backdropVariant === void 0 ? defaultProps.backdropVariant : _ref$backdropVariant,
      actions = _ref.actions,
      rest = _objectWithoutProperties(_ref, ["showClose", "heading", "headerClassName", "noContentPadding", "onRequestClose", "children", "closeTabIndex", "closeLabel", "column", "zIndex", "sizes", "renderWhenClosed", "backdrop", "backdropVariant", "actions"]);

  var showHeader = heading !== undefined || showClose;
  return ___EmotionJSX(ModalDialog, _extends({
    onRequestClose: onRequestClose,
    sizes: sizes,
    renderWhenClosed: renderWhenClosed,
    backdrop: backdrop,
    backdropVariant: backdropVariant
  }, rest), showHeader && ___EmotionJSX(ModalHeader, {
    className: headerClassName
  }, ___EmotionJSX(SmallHeadline, {
    noMargin: true
  }, heading), showClose && ___EmotionJSX(ModalCloseButton, {
    onRequestClose: onRequestClose,
    tabIndex: closeTabIndex,
    closeLabel: closeLabel
  })), ___EmotionJSX(ModalBody, {
    hasPadding: !noContentPadding,
    column: column
  }, children), ___EmotionJSX(ModalActionsContainer, {
    actions: actions
  }));
};
export default Modal;